import fetchAx from "@/axios.js";
export default {
  namespaced: true,
  state: {
    suggestionList: [],
    complaintList: [],
  },
  mutations: {
    setSuggestion(state, payload) {
      state.suggestionList = payload;
    },
    setComplaint(state, payload) {
      state.complaintList = payload;
    },
  },
  getters: {
    getSuggestionList: (state) => state.suggestionList,
    getComplaintList: (state) => state.complaintList,
  },
  actions: {
    async fetchSuggestion({ commit }) {
      const kriterler = {
        queryKey: "SikayetveOneriEvrakGetir",
        metin1: "O",
      };
      await fetchAx
        .post("v1/Dynamic/GetQueryReplaceData", kriterler)
        .then((response) => {
          commit("setSuggestion", JSON.parse(response.data.data.dataJson));
        })
        .catch((error) => {
          // console.error("Error fetching data:", error);
        });
    },
    async fetchComplaint({ commit }) {
      const kriterler = {
        queryKey: "SikayetveOneriEvrakGetir",
        metin1: "S",
      };
      await fetchAx
        .post("v1/Dynamic/GetQueryReplaceData", kriterler)
        .then((response) => {
          commit("setComplaint", JSON.parse(response.data.data.dataJson));
        })
        .catch((error) => {
          // console.error("Error fetching data:", error);
        });
    },
    async updateDoc({}, payload) {
      let request = {
        FunctionName: "d7kRun",
        MacroName: "D7KSUP007",
        JsonParams: JSON.stringify(payload),
        MacroKey: "OneriSikayetKaydet",
      };
      return new Promise(async (resolve, reject) => {
        try {
          await fetchAx
            .post("Com/RunMacroWithAuth", request)
            .then((response) => {
              if (response.status == 200) {
                if (response.data.succeeded == false) {
                  let error = {
                    color: "danger",
                    title: "Api Hatası",
                    text: response.data.message,
                    position: "top-center",
                  };
                  reject(error);
                } else {
                  let success = {
                    color: "success",
                    text: "İşlem Başarılı...",
                    position: "bottom-center",
                  };
                  // commit("setSuccess", success);
                  // response = JSON.parse(
                  //   JSON.parse(response.data.data)
                  //     .data.replace(/\#\#\#/g, '"')
                  //     .replace(/###/g, '""')
                  // );
                  // console.log(response);
                  resolve(success);
                }
              } else {
                let error = {
                  color: "danger",
                  title: "Api Hatası",
                  text: response.data.message,
                  position: "top-center",
                };
                reject(error);
              }
            });
        } catch {
          let error = {
            color: "danger",
            title: "Web Hatası",
            text: "Web tarafın bir sorun oluştu sistem yöneticiniz ile görüşünüz.!",
            acceptText: "Kapat",
            accept: null,
          };
          reject(error);
          // commit("setErrorStatus", error);
        }
      });
    },
    async fetchAction({}, payload) {
      return new Promise(async (resolve, reject) => {
        const kriterler = {
          queryKey: "SikayetveOneriSatirGetir",
          metin1: payload,
        };
        await fetchAx
          .post("v1/Dynamic/GetQueryReplaceData", kriterler)
          .then((response) => {
            resolve(JSON.parse(response.data.data.dataJson));
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
};
